import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { IProject, LibraryItemType, ProjectStatus } from '@d-id/types';

import { useTiming } from '@/hooks/useTiming';
import { getProject as getProjectApi } from '@/services/api';
import { AppRoutes } from '@/utils/types';
import { newProjectId } from '../types';

async function getProject(id: string): Promise<IProject> {
    if (id === newProjectId) {
        return {
            type: LibraryItemType.PROJECT,
            id: newProjectId,
            owner_id: 'anonymous',
            created_by: 'anonymous',
            name: 'new project',
            thumbnail_url: '',
            created_at: new Date().toISOString(),
            modified_at: new Date().toISOString(),
            status: ProjectStatus.Created,
            ready_scenes_counter: 0,
        };
    }

    return getProjectApi(id);
}

// The raw json signed url is valid for 60 minutes
const PROJECT_STALE_TIME = 55 * 60 * 1000;

export default function (id: string) {
    const navigate = useNavigate();
    const { wrapWithTiming } = useTiming();

    return useQuery(
        `get-project-${id}`,
        wrapWithTiming('getProject', () => getProject(id), { projectId: id }),
        {
            enabled: id !== '',
            refetchOnWindowFocus: false,
            onError: (error: any) => {
                if (error?.response?.data?.description === 'project not found') {
                    navigate(AppRoutes.Home);
                }
            },
            staleTime: PROJECT_STALE_TIME,
        }
    );
}
